import { type PartnerWithImageMap } from '../../partners/models/partner';

export const mapPartnerToNftPartner = (partner?: PartnerWithImageMap) => ({
	banner: partner?.images?.partnerBanner?.url,
	id: partner?.id,
	logo: partner?.images?.partnerLogo?.url,
	name: partner?.name,
	rewardsBackground: partner?.images?.partnerRewardsDefault?.url,
	shortCode: partner?.shortName
});
